/* eslint no-param-reassign: ['error', { 'props': false }] */
/* eslint no-shadow: 0 */
import { SET_DATA_LOADING } from '@/store/mutation-types';


const state = {
  data_loading: false,
};

const getters = {
  getDataLoading(state) {
    return state.data_loading;
  },
};

const mutations = {
  [SET_DATA_LOADING](state, value) {
    state.data_loading = value;
  },
};

const actions = {
  setDataLoading({ commit }, value) {
    commit(SET_DATA_LOADING, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/shared.js